import { assetPathToModelGltfUrl } from '~/utils/modelAssetUrl'

type ArmorGenderEntry = { model_gltf_url?: string; model_chr_path?: string }
type ArmorModelPaths = { male?: ArmorGenderEntry | null; female?: ArmorGenderEntry | null }

function armorGenderGltfUrl(
  paths: ArmorModelPaths | null | undefined,
  gender: 'male' | 'female'
): string | null {
  const entry = paths?.[gender]
  if (typeof entry?.model_gltf_url === 'string' && entry.model_gltf_url) {
    return entry.model_gltf_url
  }
  if (typeof entry?.model_chr_path === 'string' && entry.model_chr_path) {
    return assetPathToModelGltfUrl(entry.model_chr_path)
  }
  return null
}

/** Resolve GLB URL from enriched item JSON (matches item detail page). */
export function itemModelGltfUrl(
  item: Record<string, unknown> | null | undefined,
  options?: { armorGender?: 'male' | 'female'; armorAlt?: boolean }
): string | null {
  if (!item) return null

  const fd = item.furniture_data as Record<string, unknown> | undefined
  if (typeof fd?.model_gltf_url === 'string' && fd.model_gltf_url) {
    return fd.model_gltf_url
  }

  const wd = item.weapon_data as Record<string, unknown> | undefined
  if (typeof wd?.model_gltf_url === 'string' && wd.model_gltf_url) {
    return wd.model_gltf_url
  }
  if (typeof wd?.model_cgf_path === 'string' && wd.model_cgf_path) {
    return assetPathToModelGltfUrl(wd.model_cgf_path)
  }

  const ad = item.armor_data as Record<string, unknown> | undefined
  const gender = options?.armorGender ?? 'male'
  const useAlt = options?.armorAlt ?? false
  const primaryPaths = ad?.armor_model as ArmorModelPaths | undefined
  const altPaths = ad?.armor_model_alt as ArmorModelPaths | undefined
  const preferred = useAlt ? altPaths : primaryPaths
  const fallback = useAlt ? primaryPaths : altPaths
  return armorGenderGltfUrl(preferred, gender) ?? armorGenderGltfUrl(fallback, gender)
}
